import React from 'react';
import {connect} from 'react-redux';
import accountManagement from '../../../../../apis/accountManagement';
import KelasSearch from '../../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';
import SiswaKelasParalel from '../../../../../entity/SiswaKelasParalel';
import {cekCookies} from '../../../../../actions';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import LoaderModal from '../../../../modal/LoaderModal';
import Loader from '../../../../Loader';
import __ from 'lodash';
import { Form, Alert, Col, Row } from 'react-bootstrap';
// import ListSiswaKp from './ListSiswaKp';
import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';
import DropdownTahunAjaran from '../../masterDropDown/DropdownTahunAjaran';

class SiswaKp extends React.Component{
    constructor(props) {
        super(props);
        this.state = {    
            isFetching: false,
            alertShow: false,
            alertMessage: '',
            isOpenModalAddEdit: false,
            sekolah: {},
            ta: [],
            kodeTa: null,
            kelas: [],
            selectedKelas: null,
            idKp: null,
            SiswaKelasParalel: [],
            KelasParalelSearch: [],
            username: null,
            isSearchUsername: false,
            searchSiswa: null,
            idSiswaSelected: null,
            nameSiswaSelected: null,
            /*
            size: 5,
            page: 0,
            endPage: false,
            totalData: 0,
            */
        }
    }


    async componentDidMount() {
        this.setState({
            isFetching: true
        });
        
        await this.props.cekCookies();
        if(!__.isEmpty(this.props.account)) {
            this.fetchKelas();
            this.fetchTa();
        }

        this.setState({
            isFetching: false
        });
    }

    fetchTa = async () => {
        console.clear();
        // Fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN)
        .catch(function(error) {
            console.error('resTa Error', error);
        })

        if(resTa) {
            if(resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    ta: resTa.data.data
                })
            }
        }
        console.info('resTa', resTa);

        resTa.data.data.map((val, i) => {
            if(val.status === "1") {
                this.setState({
                    kodeTa: val.kodeTahunAjaran
                })
            }
        })
    }

    hanldeOnChangeTa = async(e) => {
        console.clear();
        this.setState({
            kodeTa: e.target.value
        })
    }

    fetchKelas = async() => {
        this.setState({
            isFetching: true
        });

        // fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah)
        .catch(function(error) {
            console.error('resSekolah Error', error);
        })
        console.error('resSekolah', resSekolah);

        if(resSekolah) {
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    sekolah: resSekolah.data.data
                })
            }
        }

        // fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch,
            ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah
        })
        .catch(function(error) {
            console.error(error);
        });

        // masukan data kelas ke dropdown
        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelas: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    handleOnChangeKelas = async (idKelas) => {
        this.setState({
            isFetching: true,
            selectedKelas: idKelas.target.value
        });
        this.state.KelasParalelSearch=[];
        this.state.SiswaKelasParalel=[];
        this.setState({
            idKp : ''
        })
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {KelasParalelSearch,
            ['idKelas']: idKelas.target.value,
            ['idSekolah']: this.props.account.idSekolah
        }).catch(function(error) {
            console.error('resKelasParalel Error', error);
        })  

        // masukan kelas paralel ke  dropdown
        if(resKelasParalel) {
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    KelasParalelSearch: resKelasParalel.data.data
                });
            }
        }

        this.setState({
            isFetching: false
        });
    }

    handleOnChangeKelasParalel = async (kode) =>{
        this.setState({
            kodeTa: kode.target.value
        })
    }

    handleOnChangeKelasParalel = async (idKelasParalel) => {
        if(!__.isEmpty(idKelasParalel.target.value)){
            this.setState({            
                idKp: idKelasParalel.target.value
            })   
        }
    }

    showSiswaSearch = async() => {
        this.setState({
            isFetching: true,
            alertShow: false
        });
        this.state.SiswaKelasParalel=null
        
        if(this.state.idKp === null) {
            this.setState({
                alertShow: true,
                isFetching: false,
                alertMessage: 'Pilih Kelas Paralel... !!'
            });
            return false;
        }
        // cari siswa di kelas tersebut
        const resSiswaKelasParelel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_KELAS_PARALEL,{...SiswaKelasParalel,
            ['idKelas']: this.state.selectedKelas,
            ['idKelasParalel']: this.state.idKp,
            ['idSekolah']: this.props.account.idSekolah,
            ['kodeTahunAjaran']: this.state.kodeTa
        }).catch (function(error) {
            console.error('resSiswaKelasParelel', error);
        });

        console.info('resSiswaKelasParelel', resSiswaKelasParelel);

        // masukan siswa ke array
        if(resSiswaKelasParelel) {
            if(resSiswaKelasParelel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    SiswaKelasParalel: resSiswaKelasParelel.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    componentDidUpdate = async () => {
        if(this.state.isSearchUsername){
            if(this.state.searchSiswa!=null || this.state.selectedKelas!=null || this.state.idKp!=null) {
                const resUsername = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_USERNAME+
                    this.state.searchSiswa+"-"+
                    this.state.kodeTa+"-"+
                    this.state.selectedKelas+"-"+
                    this.state.idKp+"-"+
                    this.props.account.idSekolah).catch (function(error){})
                this.setState({
                    SiswaKelasParalel:resUsername.data.data,
                    isSearchUsername:false
                })
            }
        }
    }

    usernameOnchange = async(e) => {
        this.setState({searchSiswa:e.target.value})
        this.setState({isSearchUsername:true, alertShow: false});
    }

    renderListSiswa() {
        console.groupCollapsed('renderListSiswa');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        if(!__.isEmpty(this.state.SiswaKelasParalel)) {
            return this.state.SiswaKelasParalel.map((siswa, i) => {
                return (
                    <tr key={i}>
                        <td>{i+1}</td>
                        <td>{siswa.username}</td>
                        <td>{siswa.namaSiswa}</td>
                        <td>{siswa.telponSiswa}</td>
                        <td>{siswa.emailSiswa}</td>
                        <td>{siswa.kodeTahunAjaran}</td>
                        <td>
                            <button className="btn btn-primary" onClick={() => this.setState({ isOpenModalAddEdit: true, idSiswaSelected: siswa.idSiswa, nameSiswaSelected: siswa.namaSiswa})}>
                                <i className="fa fa-pencil"></i>
                            </button>
                        </td>
                    </tr>
                )
            })
        }
        else {
            return (
                <tr>
                    <td colSpan="7">Tidak Ada Siswa</td>
                </tr>
            )
        }        
    }

    handleSubmit =  async (e) => {
        console.clear();
        e.preventDefault();

        this.setState({
            isFetching: true
        });
        
        const dataSend = {
            ["ID_KELAS"]: this.state.selectedKelas,
            ["ID_KELAS_PARALEL"]: this.state.idKp,
            ["ID_SISWA"]: this.state.idSiswaSelected.toString(),
            ["KODE_TAHUN_AJARAN"]: this.state.kodeTa,
            ["isUpdateJenjang"]: false
        }
        console.info('dataSend', dataSend);

        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_UPDATE_JENJANG, dataSend)
        .catch(function(error) {
            console.error('HandleSubmit Error', error);
        });
        console.info(response);
        
        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                console.info('handleSubmit', response);
            }

            this.setState({
                idSiswaSelected: null,
                nameSiswaSelected: null,
            })
        }

        this.modalDismiss();
        this.showSiswaSearch();

        this.setState({
            isFetching: false,
        })
    }

    modalAddEdit() {
        console.groupCollapsed('ModalAddEdit');
        console.info(this.state.isOpenModalAddEdit);
        console.info(this.state.idSiswaSelected);
        console.groupEnd();

        if(this.state.isOpenModalAddEdit) {
            return(
                <div className="modal fade show" id="modalLoader" style={{ display: 'block', backgroundColor: 'rgba(91, 140, 184, 0.24)', overflow: 'auto' }} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">{this.state.titleModal}</h5>
                                <span aria-hidden="true"></span>
                            </div>

                            <Form onSubmit={this.handleSubmit}>
                                <div class="modal-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Nama Siswa</label>
                                                <input className="form-control" value={this.state.nameSiswaSelected} disabled="disabled" required/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Kelas Siswa</label>
                                            <select className="form-control" value={this.state.selectedKelas} onChange={this.handleOnChangeKelas} disabled="disabled" required>
                                                <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                                <DropdownKelas kelas={this.state.kelas}/>
                                            </select>
                                        </div>

                                        <div className="col-md-6">
                                            <label>Kelas Paralel Siswa</label>
                                            <select className="form-control" value={this.state.idKp} onChange={this.handleOnChangeKelasParalel} required>
                                                <option value="" selected disabled>~~ Pilih Kelas Paralel ~~</option>
                                                <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch}/>
                                            </select>
                                        </div>
                                    </div>

                                    <br></br>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/* {this.loading()} */}
                                            {/* {this.renderKp()} */}
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger pull-left" onClick={(e) => this.modalDismiss()}>Cancel</button>
                                    <button type="submit" class="btn btn-primary pull-right">Save</button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            );
        }
    }

    modalDismiss() {
        this.setState({
            isOpenModalAddEdit : false,
            idSiswaSelected: null,
            nameSiswaSelected: null
        })
    }

    render() {
        console.groupCollapsed('Render SiswaKp');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />
                    <h4>Update Kelas Paralel</h4>
                    <div className="row">
                        <div className="col-md-3">
                            <select className="form-control" value={this.state.kodeTa} onChange={this.hanldeOnChangeTa} required>
                                <option value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                            </select>
                        </div>
                        <div className="col-md-3">
                            <select className="form-control" value={this.state.selectedKelas} onChange={this.handleOnChangeKelas} required>
                                <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                <DropdownKelas kelas={this.state.kelas} />
                            </select>
                        </div>
                        <div className="col-md-3">
                            <select className="form-control" value={this.state.idKp} onChange={this.handleOnChangeKelasParalel} required>
                                <option value="" selected disabled>~~ Pilih Kelas Paralel ~~</option>
                                <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch} />
                            </select>
                        </div>
                        <div className="col-md-2">
                            <button className="btn btn-primary" onClick={this.showSiswaSearch}><i className="fa fa-search"> Cari</i></button>
                        </div>
                    </div> 
                    <small className="pull-left" style={{marginTop: '10px'}}><i><span className="text-danger">*</span>Silahkan cari siswa berdasarkan filter yang tersedia</i></small>
                    <br/><br/>

                    <div className="row">
                        <div className="col-md-8">&nbsp;</div>
                        <div className="col-md-4">
                            <div className="col-md-12">
                                <input className="form-control" value={this.state.searchSiswa} onChange={this.usernameOnchange} placeholder="Search Siswa"/>
                            </div>
                        </div>
                    </div> 

                    {this.loadAlert()}
                    <br></br>
                    {this.loading()}

                    <div className="col-md-12">
                        <table className="table table-striped" id="myTable">
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Username</th>
                                    <th>Nama Siswa</th>
                                    <th>No Telp</th>
                                    <th>Email</th>
                                    <th>Thn Ajaran</th>
                                    <th>#</th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.renderListSiswa()}
                            </tbody>
                        </table>
                    </div>
                    
                    {this.modalAddEdit()}
                    {this.loading()}
                </div>
            </div>
        )
    }

    loading = () => {
        if(this.state.isSearchUsername){
            return(
                <Loader />
            )
        }
    }

    loadAlert = () => {
        const {alertShow, alertMessage } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{alertMessage}</strong>
            </Alert>
          );
        } 
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(SiswaKp);